import { Project } from './project.model';

export class UpdateProjectOwnerRequest {
    public ProjectId: string;
    public NewProjectOwnerId: string;
    public ProjectCommunities: string[];
    public AllCommunitiesVisibility: boolean;

    constructor(project: Project, newProjectOwnerId: string) {
        this.ProjectId = project.id;
        this.NewProjectOwnerId = newProjectOwnerId;
        this.ProjectCommunities = project.communities.map((c) => c.id);
        this.AllCommunitiesVisibility = project.allCommunitiesVisibility;
    }
}
